module.exports = __webpack_public_path__ + "static/media/logo.5749d241.svg";